import { RouterUtil } from 'kuaidong-lib'
import { CompetitionMode } from 'kuaidong-model'
import { oldCompetitionRoutes } from './RCompetitionRegion'

export default RouterUtil.cloneRoutes(oldCompetitionRoutes, 'video', '区域视频赛', { mode: CompetitionMode.Video })
